import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/index.css';

const container = document.getElementById('root');

// Falla ruidosamente en vez de montar en null: si alguien toca index.html y se
// lleva el #root por delante, el error aparece en consola en lugar de dejar una
// página en blanco sin explicación.
if (!container) {
  throw new Error('No se encontró el elemento #root en index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
